import script from "./HomeHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeHeader.vue?vue&type=script&setup=true&lang=ts"

import "./HomeHeader.vue?vue&type=style&index=0&id=46cd4983&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46cd4983"]])

export default __exports__